<div class="auth-required-container">
  <h2>Authentication Required</h2>
  <p>{{ message }}</p>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="goToComtrak()">Go to Comtrak</button>
    <button mat-stroked-button color="accent" [disabled]="busy" (click)="tryAgain()">
      {{ busy ? 'Validating...' : 'Try again' }}
    </button>
  </div>
  <p style="margin-top: 12px; color: #666;">If you just authenticated in another tab, click "Try again".</p>
  
</div>





